/**
 * Distorts points towards a clean square shape
 * @param {number} x - X coordinate
 * @param {number} y - Y coordinate
 * @param {number} width - Canvas width
 * @param {number} height - Canvas height
 * @returns {Object} Distorted point {x, y}
 */
export const squareDistortionCleaner = (x, y, width, height) => {
  const centerX = width / 2;
  const centerY = height / 2;

  // Calculate normalized position relative to center
  const normX = (x - centerX) / centerX;
  const normY = (y - centerY) / centerY;

  // Calculate distance from center as a max norm (square shape)
  const centerDist = Math.max(Math.abs(normX), Math.abs(normY));


  // Calculate pull factor with smooth falloff
  const pullFactor = Math.max(0, (1 - centerDist / 0.7));

  let newX = x;
  let newY = y;

  // Apply distortion only in the dominant direction
  if (Math.abs(normX) > Math.abs(normY)) {
    // Horizontal pull is dominant (left or right)
    if (normX < 0) {
      newX =  x - Math.pow(pullFactor, 1.5) * centerX;
    } else {
      newX = x + Math.pow(pullFactor, 1.5) * centerX;
    }
  } else {
    // Vertical pull is dominant (up or down)
    if (normY < 0) {
      newY = y - Math.pow(pullFactor, 1.5) * centerY;
    } else {
      newY = y + Math.pow(pullFactor, 1.5) * centerY;
    }
  }

  const staticRandomPlusMinus = (Math.abs(Math.sin(x * 12.9898 + y * 78.233) * 43758.5453) % 1) * 2 - 1;

  newX += staticRandomPlusMinus * 50;
  newY += staticRandomPlusMinus * 50;

  return { x: newX, y: newY };
};
